module.exports = __webpack_public_path__ + "img/winerackdog35.0ad7dcb6.jpg";